module.exports = __webpack_public_path__ + "img/profile-wallet-inactive.70f1c38e.svg";